import _ from 'lodash';
import React, { useState } from 'react';

import { AudioPlayer } from 'components/AudioPlayer';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import PodcastIcon from 'mdi-material-ui/Podcast';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
dayjs.extend(duration);

const ListenServices = [
  {
    name: 'Apple Podcasts',
    key: 'apple_podcasts'
  },
  {
    name: 'Spotify',
    key: 'spotify'
  },
  {
    name: 'Stitcher',
    key: 'stitcher'
  },
  {
    name: 'Tune In',
    key: 'tune_in'
  }
];

const PodcastPlayer = ({ episode }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  return episode ? (
    <Grid container alignItems="center" justify="space-between">
      <Grid item xs={_.some(episode?.listen_links) ? 10 : 12}>
        <AudioPlayer file={episode.audio} />
      </Grid>
      {_.some(episode?.listen_links) && (
        <Grid item xs={2}>
          <Button onClick={e => setAnchorEl(e.currentTarget)}>
            <PodcastIcon />
            &nbsp;Listen&nbsp;On
          </Button>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
            disableAutoFocusItem
          >
            {(ListenServices || []).map((service, idx) => (
              <MenuItem
                href={episode?.listen_links?.[service.key]}
                target="_blank"
                button
                component="a"
              >
                {service.name}
              </MenuItem>
            ))}
          </Menu>
        </Grid>
      )}
    </Grid>
  ) : null;
};

export default PodcastPlayer;
